var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"orders-timeline-button",attrs:{"top":"","fab":"","right":"","fixed":"","color":"primary"},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v(_vm._s((!_vm.value) ? 'mdi-clock' : 'mdi-close'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }